import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0bb7ef67"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-h5 ringbearer" }, "Partidas validadas", -1))
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "No tienes partidas validadas", -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-h5 ringbearer" }, "Partidas de torneo", -1))
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "No tiene partidas de torneo", -1))
const _hoisted_12 = [
  _hoisted_11
]

import { ref, onMounted, computed, ComputedRef } from "vue";
import { useRoute, useRouter } from "vue-router";
import PerfilUsuarioView from "@/views/PerfilUsuarioView.vue";
import {
  ViewPartidaAmistosaDTO,
  ViewPartidaTorneoDTO,
} from "@/interfaces/Partidas";
import { UsuarioDataDTO } from "@/interfaces/Usuario";
import ValidadasMatchCard from "@/components/PartidaAmistosa/ValidadasMatchCard.vue";
import LoadingGandalf from "@/components/Commons/LoadingGandalf.vue";
import { useUsuariosStore } from "@/store/usuarios";
import CardPartidaTorneo from "@/components/PartidasTorneo/CardPartidaTorneo.vue";
import { getTournamentMatches } from "@/services/PartidaTorneoService";
import TablaInscripcionesTorneoIndividual from "@/components/Inscripcion/TablaInscripcionesTorneoIndividual.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DetalleJugadorView',
  setup(__props) {

const tab = ref<string>("one");
const usuariosStore = useUsuariosStore();

const isLoading = ref(true);
const isLoadingTournamentMatches = ref<boolean>(false);

const router = useRouter();
const route = useRoute();
const usuarioData: ComputedRef<UsuarioDataDTO> = computed(
  () => usuariosStore.usuarioData
);

const pendingMatches = ref<ViewPartidaAmistosaDTO[]>([]);
const validMatches = ref<ViewPartidaAmistosaDTO[]>([]);
const tournamentMatches = ref<ViewPartidaTorneoDTO[]>([]);

const cargarPartidasTorneos = async () => {
  try {
    isLoadingTournamentMatches.value = true;
    const response = await getTournamentMatches(usuarioData.value.idUsuario);

    tournamentMatches.value = response.data;
    tournamentMatches.value = tournamentMatches.value.sort((a, b) => {
      return (
        new Date(b.fechaPartida).getTime() - new Date(a.fechaPartida).getTime()
      );
    });
  } catch (error) {
    console.error("Error al obtener las partidas de torneo:", error);
  } finally {
    isLoadingTournamentMatches.value = false;
  }
};

const initializeComponent = async () => {
  isLoading.value = true;
  try {
    const idRecibido = String(route.params.idUsuario);
    await usuariosStore.requestUsuarioData(parseInt(idRecibido));

    // Verifica la estructura de usuarioResponse
    if (usuarioData.value.idUsuario) {
      validMatches.value = usuarioData.value.partidasValidadas.sort((a, b) => {
        return (
          new Date(b.fechaPartida).getTime() -
          new Date(a.fechaPartida).getTime()
        );
      });
      pendingMatches.value = usuarioData.value.partidasPendientes.sort(
        (a, b) => {
          return (
            new Date(b.fechaPartida).getTime() -
            new Date(a.fechaPartida).getTime()
          );
        }
      );
      cargarPartidasTorneos();
    }
  } catch (error) {
    console.error(error);
    router.push({ name: "error" });
  } finally {
    isLoading.value = false;
  }
};

onMounted(initializeComponent);

const goBack = () => {
  router.back();
};

return (_ctx: any,_cache: any) => {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "text-center" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { dense: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            md: "12",
            class: "text-center"
          }, {
            default: _withCtx(() => [
              (isLoading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(LoadingGandalf)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(_component_v_tabs, {
                      modelValue: tab.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tab).value = $event)),
                      color: "primary",
                      grow: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_tab, { value: "1" }, {
                          default: _withCtx(() => [
                            _createTextVNode("Perfil")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_tab, { value: "2" }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Amistosas ")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_tab, { value: "3" }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Torneos ")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_tab, { value: "4" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, { icon: "mdi-calendar-account-outline" })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_v_window, {
                      modelValue: tab.value,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((tab).value = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_window_item, { value: "1" }, {
                          default: _withCtx(() => [
                            _createVNode(PerfilUsuarioView, {
                              email: usuarioData.value.email,
                              editable: false
                            }, null, 8, ["email"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_window_item, { value: "2" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_divider, { class: "my-3" }),
                            (!isLoading.value && validMatches.value.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                  _createVNode(_component_v_card, { class: "section-card stats-section pt-0 mt-0" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, { cols: "12" }, {
                                        default: _withCtx(() => [
                                          _hoisted_4
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_divider),
                                      _createVNode(_component_v_row, null, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(validMatches.value, (match) => {
                                            return (_openBlock(), _createBlock(_component_v_col, {
                                              cols: "12",
                                              sm: "6",
                                              md: "6",
                                              lg: "4",
                                              xl: "4",
                                              class: "pb-0",
                                              key: match.idPartidaAmistosa
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(ValidadasMatchCard, {
                                                  idUsuario: usuarioData.value.idUsuario,
                                                  match: match,
                                                  class: "mb-4"
                                                }, null, 8, ["idUsuario", "match"])
                                              ]),
                                              _: 2
                                            }, 1024))
                                          }), 128))
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7)),
                            _createVNode(_component_v_divider, { class: "my-3" })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_window_item, { value: "3" }, {
                          default: _withCtx(() => [
                            (!isLoading.value && tournamentMatches.value.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                  _createVNode(_component_v_card, { class: "section-card stats-section pt-0 mt-0" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, { cols: "12" }, {
                                        default: _withCtx(() => [
                                          _hoisted_9
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_divider),
                                      _createVNode(_component_v_row, null, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tournamentMatches.value, (match) => {
                                            return (_openBlock(), _createBlock(_component_v_col, {
                                              cols: "12",
                                              sm: "6",
                                              md: "6",
                                              lg: "4",
                                              xl: "4",
                                              class: "pb-0",
                                              key: match.idPartidaTorneo
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(CardPartidaTorneo, {
                                                  idUsuario: usuarioData.value.idUsuario,
                                                  match: match,
                                                  class: "mb-4"
                                                }, null, 8, ["idUsuario", "match"])
                                              ]),
                                              _: 2
                                            }, 1024))
                                          }), 128))
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12)),
                            _createVNode(_component_v_divider, { class: "my-3" })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_window_item, { value: "4" }, {
                          default: _withCtx(() => [
                            _createVNode(TablaInscripcionesTorneoIndividual, {
                              isLoading: isLoading.value,
                              listaTorneos: usuarioData.value.InscripcionesIndividualTorneo,
                              idUsuario: usuarioData.value.idUsuario,
                              disputado: false
                            }, null, 8, ["isLoading", "listaTorneos", "idUsuario"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]))
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, {
            align: "center",
            justify: "center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "auto" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    color: "orange",
                    variant: "tonal",
                    class: "login-form__button mt-4",
                    onClick: goBack
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Volver ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})